import React, { Fragment } from 'react';
import { connect } from "react-redux";
import AangemeldPageHelper from './AangemeldPageHelper';
import redirector from "../../../util/redirector";
import AutoBindComponent from "../../common/AutoBindComponent";

class AangemeldPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, false);
        this.pageHelper = new AangemeldPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    render() {
        return (<Fragment></Fragment>);
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch, ownProps) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AangemeldPage);
